import { render, staticRenderFns } from "./purchaseOrderFee.vue?vue&type=template&id=46f43450&scoped=true"
import script from "./purchaseOrderFee.vue?vue&type=script&lang=ts"
export * from "./purchaseOrderFee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f43450",
  null
  
)

export default component.exports